(function () {
  const init = (root) => {
    const burger = root.querySelector('[data-brand-mega-burger]');
    const drawer = root.querySelector('[data-brand-mega-drawer]');
    const overlay = root.querySelector('[data-brand-mega-overlay]');
    const closeEls = root.querySelectorAll('[data-brand-mega-close]');

    if (!burger || !drawer) return;

    const openLabel = burger.getAttribute('data-aria-open') || '';
    const shutLabel = burger.getAttribute('data-aria-shut') || '';

    const setOpen = (open) => {
      root.classList.toggle('brand-mega-menu--open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (openLabel && shutLabel) burger.setAttribute('aria-label', open ? shutLabel : openLabel);
      document.body.classList.toggle('brand-mega-menu-body-lock', open);
    };

    burger.addEventListener('click', () => setOpen(!root.classList.contains('brand-mega-menu--open')));

    overlay?.addEventListener('click', () => setOpen(false));

    closeEls.forEach((el) => el.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('brand-mega-menu--open')) setOpen(false);
    });
  };

  document.querySelectorAll('[data-brand-mega-header]').forEach(init);
})();
